import { Grid } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import Description from '@mui/icons-material/Description';
import Layers from '@mui/icons-material/Layers';
import FlashOn from '@mui/icons-material/FlashOn';
import AccessTime from '@mui/icons-material/AccessTime';
import Person from '@mui/icons-material/Person';
import InfoItem from '../components/InfoItem';
import { getValue, getTeacherName } from '../utils';

const OverviewTab = ({
  behavior,
  teachersForStudent,
  isBehaviorType,
  isSkillType,
  user,
}) => (
  <Grid container spacing={3}>
    <InfoItem
      icon={<CategoryIcon fontSize='small' sx={{ color: 'white' }} />}
      label='Categories'
      value={getValue(behavior?.info?.BehaviorDetails?.BehaviorCategory)}
      xs={12}
      sm={6}
    />

    <InfoItem
      icon={<Layers fontSize='small' sx={{ color: 'white' }} />}
      label={isBehaviorType ? 'Behavior Type' : 'Skill Type'}
      value={getValue(
        isBehaviorType
          ? behavior?.info?.BehaviorDetails?.Type?.BehaviorType
          : behavior?.info?.BehaviorDetails?.Type?.SkillType
      )}
      xs={12}
      sm={6}
    />

    <InfoItem
      icon={<Description fontSize='small' sx={{ color: 'white' }} />}
      label={isBehaviorType ? 'Behavior Name' : 'Skill Name'}
      value={getValue(
        isBehaviorType
          ? behavior?.info?.BehaviorDetails?.Type?.BehaviorName
          : behavior?.info?.BehaviorDetails?.Type?.SkillName
      )}
      xs={12}
      sm={6}
    />

    <InfoItem
      icon={<Description fontSize='small' sx={{ color: 'white' }} />}
      label='Definition'
      value={getValue(
        isBehaviorType
          ? behavior?.info?.BehaviorDetails?.Type?.Definition
          : behavior?.info?.BehaviorDetails?.Type?.SkillDefinition
      )}
      xs={12}
      sm={6}
    />

    {isBehaviorType && (
      <InfoItem
        icon={<FlashOn fontSize='small' sx={{ color: 'white' }} />}
        label='Onset'
        value={getValue(behavior?.info?.BehaviorDetails?.Type?.Onset)}
        xs={12}
        sm={6}
      />
    )}

    {isBehaviorType && (
      <InfoItem
        icon={<AccessTime fontSize='small' sx={{ color: 'white' }} />}
        label='Offset'
        value={getValue(behavior?.info?.BehaviorDetails?.Type?.Offset)}
        xs={12}
        sm={6}
      />
    )}

    {isSkillType && (
      <InfoItem
        icon={<Description fontSize='small' sx={{ color: 'white' }} />}
        label='Natural Cue'
        value={getValue(
          behavior?.info?.BehaviorDetails?.Type?.SkillNaturalCue
        )}
        xs={12}
        sm={6}
      />
    )}

    <InfoItem
      icon={<Person fontSize='small' sx={{ color: 'white' }} />}
      label='Author'
      value={getTeacherName(
        teachersForStudent,
        behavior?.info?.BehaviorDetails?.BehaviorAuthor,
        behavior,
        user
      )}
      xs={12}
      sm={6}
    />
  </Grid>
);

export default OverviewTab;

